// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/NotoSerifToto-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/dyno.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/faq-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Noto;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 400;
    font-style: normal;
    display: swap;
}

.TicketEventPage_ticketPage__gX2oQ {
    font-family: 'Noto', serif;
}

.TicketEventPage_header__0JVCP {
    position: relative;
    width: 100%;
    height: 270px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    overflow: hidden;
    z-index: 3;
}

.TicketEventPage_header__0JVCP::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: 0;
    width: 100%;
    height: 150px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 -20px 0 60px white;
    z-index: 1;
}

.TicketEventPage_headersLocationName__jenIm {
    color: white;
    font-weight: bold;
    font-size: 30px;
    margin-top: 30px;
}

.TicketEventPage_infoHeader__mUwJk {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.TicketEventPage_logoImage__BFHAk {
    width: 65px;
    height: 70px;
    margin-top: 12px;
}

.TicketEventPage_creepersImage__\\+OpbO {
    position: absolute;
    right: 0;
    top: 132px;
    width: 200px;
    height: 200px;
    z-index: 3;
}

.TicketEventPage_container__dMAMX {
    display: flex;
    flex-direction: row;
    height: 380px;
    width: 100%;
    margin-bottom: 200px;
    justify-content: space-around;
}

.TicketEventPage_leftSection__VMY6N {
    width: 400px;
    height: 500px;
    margin-right: 30px;
}

.TicketEventPage_rightSection__qnlXc {
    width: 400px;
    display: flex;
    flex-direction: column;
    margin-right: auto;
    margin-top: -24px;

}

img {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 6px;
    max-height: 100%;
}

button {
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
}

.TicketEventPage_page__EDyb0 {
    display: flex;
    flex-direction: column;
    padding: 80px 200px;
    margin-top: -70px;
}

.TicketEventPage_description__XkTHF {
    width: 100%;
    border-top: gray 2px solid;
    padding-top: 20px;
}

.TicketEventPage_blockInfo__\\+DHGu {
    font-size: 16px;
    margin-bottom: 4px;
    display: flex;
    width: 100%;
    flex-direction: row;
}

.TicketEventPage_blockDay__AoK7Q {
    font-size: 32px;
    margin-bottom: 4px;
    display: block;
    font-weight: 600;
    color: #357CEF;
    margin-right: 10px;
    margin-left: 10px;
}

.TicketEventPage_blockWeek__3vXna {
    font-size: 32px;
    margin-bottom: 4px;
    display: block;
    font-weight: 600;
    text-transform: uppercase;
    color: #357CEF;
}

.TicketEventPage_blockTime__xaZii {
    font-size: 32px;
    margin-bottom: 4px;
    display: block;
    font-weight: 300;

}

.TicketEventPage_btnGradient__ZsJKC {
    border-radius: 7px;
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 12px;
    width: 320px;
    color: #ffffff;
    background: linear-gradient(90deg, rgba(61, 150, 255, 1) 0%, rgba(120, 56, 255, 1) 100%);
    box-shadow: 0 5px 10px 0 rgba(119, 56, 255, 0.25);
}

select option {
    margin: 40px;
    background: rgba(61, 150, 255, 1) 0%;
    color: black;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}

.TicketEventPage_blockCountry1__Q2E9r {
    margin-right: 20px;
    font-weight: 700;
}

.TicketEventPage_blockInput__JvxD0 {
    display: flex;
    flex-direction: column;
    justify-self: flex-end;
    margin-top: auto;
}

input {
    padding: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    width: 295px;
    border-radius: 5px;
    margin-top: 5px;
}

h1 {
    line-height: 54px;
    font-size: 36px;
}
.TicketEventPage_nameLinkDisabled__nlr9a {
    color: gray;
    cursor: not-allowed;
    text-decoration: none;
}

.TicketEventPage_error__ql3na {
    color: red;
}

.TicketEventPage_titleAndAge__AvY-f {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.TicketEventPage_titleAndAge__AvY-f p {
    font-size: 20px;
}

.TicketEventPage_moneyBlock__W7HsP {
    margin-top: 10px;
    font-weight: bold;
}

.TicketEventPage_footer__IAogb {
    display: flex;
    position: relative;
    flex-direction: column;
    background-color: black;
    justify-content: center;
    align-items: center;
    height: auto;
    color: white;
}

.TicketEventPage_footerLinksBlock__YkEEb {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    width: 60%;
}

.TicketEventPage_footerLinks__QTkxP {
    display: flex;
    flex-direction: column;

}

a {
    margin-top: 10px;
    text-decoration: none;
    color: white;
    font-weight: bold;
}

.TicketEventPage_footerLinks__QTkxP a:hover {
    margin-top: 10px;
    text-decoration: none;
    color: blue;
    font-weight: bold;
}

.TicketEventPage_block3__K4qVq {
    display: flex;
    flex-direction: column;
}

.TicketEventPage_footerPaymentsBlock__0O4Aa {
    display: flex;
    flex-direction: column;

}

.TicketEventPage_logoImageFooter__S7V29 {
    height: 101px;
    width: 95px;
    margin-right: 40px;
}

.TicketEventPage_mainFootersComponent__dv8tw {
    display: flex;
    height: 120px;
    width: 60%;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 60px;
    padding-bottom: 35px;
    border-bottom: 2px solid white;
}

.TicketEventPage_footerDown__B3FXQ {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 60%;
}

.TicketEventPage_leafsImageFooter__zHP0o {
    position: absolute;
    top: -72%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

.TicketEventPage_paymentImage__VnluJ {
    width: 140px;
    height: 30px;
    border-radius: 0px;
    margin-top: 10px;
    margin-bottom: 10px;
    object-fit: contain;

}

.TicketEventPage_paymentImage2__gX1H1 {
    width: 150px;
    height: 40px;
    border-radius: 0px;
    margin-bottom: 10px;
    object-fit: contain;
    margin-left: -25px;
}

.TicketEventPage_paymentsBlockImagesTwo__UmO8n {
    display: flex;
    flex-direction: row;
}

.TicketEventPage_scrollToTop__wdhai {
    position: fixed;
    bottom: 200px;
    right: 40px;
    width: 50px;
    height: 50px;
    background-color: orange;
    color: white;
    border: none;
    border-radius: 50%;
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.TicketEventPage_scrollToTop__wdhai:hover {
    background-color: darkorange;
}

.TicketEventPage_ruleHeader__E4I-6 {
    background-color: #e5d14e;
    color: black;
    font-size: 26px;
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.TicketEventPage_ruleSection__\\+Cb-i {
    display: flex;
    flex-direction: column;
    width: 60%;
}

.TicketEventPage_ruleContent__lcVbZ p {
    margin-top: 5px;
}

.TicketEventPage_rulesBlock__hFslW {
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-self: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
    margin-top: 100px;
    margin-bottom: 100px;
    padding-bottom: 150px;
    padding-top: 150px;
}

.TicketEventPage_ruleContent__lcVbZ {
    background-color: white;
    padding: 25px 20px;
}

.TicketEventPage_rulesBlock__hFslW h2 {
    font-size: 36px;
}

@media(max-width: 965px){

    .TicketEventPage_header__0JVCP {
        background-size: cover;
        background-position: left;
        height: 210px;
    }

    .TicketEventPage_header__0JVCP::after {
        height: 115px;
    }

    .TicketEventPage_headersLocationName__jenIm {
        font-size: 22px;
        margin-top: 22px;
    }

    .TicketEventPage_infoHeader__mUwJk {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-right: 10px;
        padding-left: 10px;
    }

    .TicketEventPage_creepersImage__\\+OpbO {
        position: absolute;
        right: 10px;
        top: 75px;
        width: 200px;
        height: 120px;
        z-index: 3;

    }

    .TicketEventPage_logoImage__BFHAk {
        width: 50px;
        height: 55px;
        margin-top: 12px;
    }

    .TicketEventPage_page__EDyb0 {
        margin-top: 1px;
    }

    .TicketEventPage_container__dMAMX {
        display: flex;
        flex-direction: column;
        height: auto;
        width: 100%;
        margin-bottom: 40px;
        justify-content: space-between;
    }

    .TicketEventPage_leftSection__VMY6N {
        width: 100%;
        height: 100%;
    }

    .TicketEventPage_rightSection__qnlXc {
        width: 100%;
        display: flex;
        flex-direction: column;

    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    button {
        padding: 10px;
        font-size: 16px;
        cursor: pointer;
        width: 100%;
    }

    .TicketEventPage_page__EDyb0 {
        display: flex;
        flex-direction: column;
        padding: 20px;
    }

    .TicketEventPage_btnGradient__ZsJKC {
        width: 100%;
    }

    input {
        font-size: 16px;
        width: 92%;
        border-radius: 7px;
        margin-top: 8px;
        margin-bottom: 10px;
        padding: 12px;
    }

    .TicketEventPage_blockDay__AoK7Q {
        font-size: 18px;
        margin-bottom: 4px;
        display: block;
        font-weight: 600;
        color: #357CEF;
        margin-right: 8px;
        margin-left: 10px;
    }

    .TicketEventPage_blockWeek__3vXna {
        font-size: 18px;
        margin-bottom: 4px;
        display: block;
        font-weight: 600;
        text-transform: uppercase;
        color: #357CEF;
    }

    .TicketEventPage_blockTime__xaZii {
        font-size: 18px;
        margin-bottom: 4px;
        display: block;
        font-weight: 300;

    }
    .TicketEventPage_blockCountry1__Q2E9r {
        margin-bottom: 10px;

    }

    .TicketEventPage_footer__IAogb {
        height: 800px;
        padding-left: 5px;
    }

    .TicketEventPage_footerLinksBlock__YkEEb {
        flex-direction: column;
        width: 100%;
    }

    .TicketEventPage_leafsImageFooter__zHP0o {
        position: absolute;
        top: -8%;
        left: 20%;

        height: 90px;
        transform: translateX(-20%);
        z-index: 2;
    }

    .TicketEventPage_mainFootersComponent__dv8tw {
        height: auto;
        width: 100%;
        flex-direction: column;
        padding-top: 0px;
        padding-bottom: 80px;
    }

    .TicketEventPage_footerDown__B3FXQ {
        flex-direction: column;
        width: 100%;
    }

    .TicketEventPage_scrollToTop__wdhai {
        bottom: 120px;
        right: 20px;
        width: 40px;
        height: 40px;
    }

    a {
        margin-top: 30px;
    }

    .TicketEventPage_footerPaymentsBlock__0O4Aa {
        margin-top: 30px;

    }

    .TicketEventPage_ruleHeader__E4I-6 {
        font-size: 20px;
        padding-left: 16px;
        padding-top: 6px;
        padding-bottom: 6px;
    }

    .TicketEventPage_ruleSection__\\+Cb-i {
        width: 100%;
    }

    .TicketEventPage_ruleContent__lcVbZ p {
        margin-top: 5px;
    }

    .TicketEventPage_rulesBlock__hFslW {
        margin-top: 60px;
        margin-bottom: 60px;
        padding-bottom: 100px;
        padding-top: 100px;
    }

    .TicketEventPage_ruleContent__lcVbZ {
        padding: 20px 15px;

    }

    .TicketEventPage_rulesBlock__hFslW h2 {
        font-size: 28px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/pages/TicketEventPage.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,+DAA2E;IAC3E,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yDAAwC;IACxC,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,wFAAwF;IACxF,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,yDAA0C;IAC1C,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI;QACI,sBAAsB;QACtB,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,YAAY;QACZ,aAAa;QACb,UAAU;;IAEd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;;IAE1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;QACV,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,gBAAgB;;IAEpB;IACA;QACI,mBAAmB;;IAEvB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;;QAET,YAAY;QACZ,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;;IAEpB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;;IAEtB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["@font-face {\n    font-family: Noto;\n    src: url('../fonts/NotoSerifToto-VariableFont_wght.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n    display: swap;\n}\n\n.ticketPage {\n    font-family: 'Noto', serif;\n}\n\n.header {\n    position: relative;\n    width: 100%;\n    height: 270px;\n    background-image: url('../img/dyno.png');\n    background-size: cover;\n    background-position: center;\n    overflow: hidden;\n    z-index: 3;\n}\n\n.header::after {\n    content: '';\n    position: absolute;\n    bottom: -50px;\n    left: 0;\n    width: 100%;\n    height: 150px;\n    background: white;\n    border-radius: 50%;\n    box-shadow: 0 -20px 0 60px white;\n    z-index: 1;\n}\n\n.headersLocationName {\n    color: white;\n    font-weight: bold;\n    font-size: 30px;\n    margin-top: 30px;\n}\n\n.infoHeader {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n}\n\n.logoImage {\n    width: 65px;\n    height: 70px;\n    margin-top: 12px;\n}\n\n.creepersImage {\n    position: absolute;\n    right: 0;\n    top: 132px;\n    width: 200px;\n    height: 200px;\n    z-index: 3;\n}\n\n.container {\n    display: flex;\n    flex-direction: row;\n    height: 380px;\n    width: 100%;\n    margin-bottom: 200px;\n    justify-content: space-around;\n}\n\n.leftSection {\n    width: 400px;\n    height: 500px;\n    margin-right: 30px;\n}\n\n.rightSection {\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    margin-right: auto;\n    margin-top: -24px;\n\n}\n\nimg {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    border-radius: 6px;\n    max-height: 100%;\n}\n\nbutton {\n    padding: 10px;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.page {\n    display: flex;\n    flex-direction: column;\n    padding: 80px 200px;\n    margin-top: -70px;\n}\n\n.description {\n    width: 100%;\n    border-top: gray 2px solid;\n    padding-top: 20px;\n}\n\n.blockInfo {\n    font-size: 16px;\n    margin-bottom: 4px;\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n}\n\n.blockDay {\n    font-size: 32px;\n    margin-bottom: 4px;\n    display: block;\n    font-weight: 600;\n    color: #357CEF;\n    margin-right: 10px;\n    margin-left: 10px;\n}\n\n.blockWeek {\n    font-size: 32px;\n    margin-bottom: 4px;\n    display: block;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #357CEF;\n}\n\n.blockTime {\n    font-size: 32px;\n    margin-bottom: 4px;\n    display: block;\n    font-weight: 300;\n\n}\n\n.btnGradient {\n    border-radius: 7px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    padding: 12px;\n    width: 320px;\n    color: #ffffff;\n    background: linear-gradient(90deg, rgba(61, 150, 255, 1) 0%, rgba(120, 56, 255, 1) 100%);\n    box-shadow: 0 5px 10px 0 rgba(119, 56, 255, 0.25);\n}\n\nselect option {\n    margin: 40px;\n    background: rgba(61, 150, 255, 1) 0%;\n    color: black;\n    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);\n}\n\n.blockCountry1 {\n    margin-right: 20px;\n    font-weight: 700;\n}\n\n.blockInput {\n    display: flex;\n    flex-direction: column;\n    justify-self: flex-end;\n    margin-top: auto;\n}\n\ninput {\n    padding: 10px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    width: 295px;\n    border-radius: 5px;\n    margin-top: 5px;\n}\n\nh1 {\n    line-height: 54px;\n    font-size: 36px;\n}\n.nameLinkDisabled {\n    color: gray;\n    cursor: not-allowed;\n    text-decoration: none;\n}\n\n.error {\n    color: red;\n}\n\n.titleAndAge {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.titleAndAge p {\n    font-size: 20px;\n}\n\n.moneyBlock {\n    margin-top: 10px;\n    font-weight: bold;\n}\n\n.footer {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    background-color: black;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n    color: white;\n}\n\n.footerLinksBlock {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 10px;\n    width: 60%;\n}\n\n.footerLinks {\n    display: flex;\n    flex-direction: column;\n\n}\n\na {\n    margin-top: 10px;\n    text-decoration: none;\n    color: white;\n    font-weight: bold;\n}\n\n.footerLinks a:hover {\n    margin-top: 10px;\n    text-decoration: none;\n    color: blue;\n    font-weight: bold;\n}\n\n.block3 {\n    display: flex;\n    flex-direction: column;\n}\n\n.footerPaymentsBlock {\n    display: flex;\n    flex-direction: column;\n\n}\n\n.logoImageFooter {\n    height: 101px;\n    width: 95px;\n    margin-right: 40px;\n}\n\n.mainFootersComponent {\n    display: flex;\n    height: 120px;\n    width: 60%;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 60px;\n    padding-bottom: 35px;\n    border-bottom: 2px solid white;\n}\n\n.footerDown {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 60%;\n}\n\n.leafsImageFooter {\n    position: absolute;\n    top: -72%;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n}\n\n.paymentImage {\n    width: 140px;\n    height: 30px;\n    border-radius: 0px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    object-fit: contain;\n\n}\n\n.paymentImage2 {\n    width: 150px;\n    height: 40px;\n    border-radius: 0px;\n    margin-bottom: 10px;\n    object-fit: contain;\n    margin-left: -25px;\n}\n\n.paymentsBlockImagesTwo {\n    display: flex;\n    flex-direction: row;\n}\n\n.scrollToTop {\n    position: fixed;\n    bottom: 200px;\n    right: 40px;\n    width: 50px;\n    height: 50px;\n    background-color: orange;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    font-size: 24px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.scrollToTop:hover {\n    background-color: darkorange;\n}\n\n.ruleHeader {\n    background-color: #e5d14e;\n    color: black;\n    font-size: 26px;\n    padding-left: 30px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.ruleSection {\n    display: flex;\n    flex-direction: column;\n    width: 60%;\n}\n\n.ruleContent p {\n    margin-top: 5px;\n}\n\n.rulesBlock {\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-self: center;\n    background-image: url('../img/faq-bg.jpg');\n    background-size: cover;\n    background-position: center;\n    margin-top: 100px;\n    margin-bottom: 100px;\n    padding-bottom: 150px;\n    padding-top: 150px;\n}\n\n.ruleContent {\n    background-color: white;\n    padding: 25px 20px;\n}\n\n.rulesBlock h2 {\n    font-size: 36px;\n}\n\n@media(max-width: 965px){\n\n    .header {\n        background-size: cover;\n        background-position: left;\n        height: 210px;\n    }\n\n    .header::after {\n        height: 115px;\n    }\n\n    .headersLocationName {\n        font-size: 22px;\n        margin-top: 22px;\n    }\n\n    .infoHeader {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        padding-right: 10px;\n        padding-left: 10px;\n    }\n\n    .creepersImage {\n        position: absolute;\n        right: 10px;\n        top: 75px;\n        width: 200px;\n        height: 120px;\n        z-index: 3;\n\n    }\n\n    .logoImage {\n        width: 50px;\n        height: 55px;\n        margin-top: 12px;\n    }\n\n    .page {\n        margin-top: 1px;\n    }\n\n    .container {\n        display: flex;\n        flex-direction: column;\n        height: auto;\n        width: 100%;\n        margin-bottom: 40px;\n        justify-content: space-between;\n    }\n\n    .leftSection {\n        width: 100%;\n        height: 100%;\n    }\n\n    .rightSection {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n\n    }\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    button {\n        padding: 10px;\n        font-size: 16px;\n        cursor: pointer;\n        width: 100%;\n    }\n\n    .page {\n        display: flex;\n        flex-direction: column;\n        padding: 20px;\n    }\n\n    .btnGradient {\n        width: 100%;\n    }\n\n    input {\n        font-size: 16px;\n        width: 92%;\n        border-radius: 7px;\n        margin-top: 8px;\n        margin-bottom: 10px;\n        padding: 12px;\n    }\n\n    .blockDay {\n        font-size: 18px;\n        margin-bottom: 4px;\n        display: block;\n        font-weight: 600;\n        color: #357CEF;\n        margin-right: 8px;\n        margin-left: 10px;\n    }\n\n    .blockWeek {\n        font-size: 18px;\n        margin-bottom: 4px;\n        display: block;\n        font-weight: 600;\n        text-transform: uppercase;\n        color: #357CEF;\n    }\n\n    .blockTime {\n        font-size: 18px;\n        margin-bottom: 4px;\n        display: block;\n        font-weight: 300;\n\n    }\n    .blockCountry1 {\n        margin-bottom: 10px;\n\n    }\n\n    .footer {\n        height: 800px;\n        padding-left: 5px;\n    }\n\n    .footerLinksBlock {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .leafsImageFooter {\n        position: absolute;\n        top: -8%;\n        left: 20%;\n\n        height: 90px;\n        transform: translateX(-20%);\n        z-index: 2;\n    }\n\n    .mainFootersComponent {\n        height: auto;\n        width: 100%;\n        flex-direction: column;\n        padding-top: 0px;\n        padding-bottom: 80px;\n    }\n\n    .footerDown {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .scrollToTop {\n        bottom: 120px;\n        right: 20px;\n        width: 40px;\n        height: 40px;\n    }\n\n    a {\n        margin-top: 30px;\n    }\n\n    .footerPaymentsBlock {\n        margin-top: 30px;\n\n    }\n\n    .ruleHeader {\n        font-size: 20px;\n        padding-left: 16px;\n        padding-top: 6px;\n        padding-bottom: 6px;\n    }\n\n    .ruleSection {\n        width: 100%;\n    }\n\n    .ruleContent p {\n        margin-top: 5px;\n    }\n\n    .rulesBlock {\n        margin-top: 60px;\n        margin-bottom: 60px;\n        padding-bottom: 100px;\n        padding-top: 100px;\n    }\n\n    .ruleContent {\n        padding: 20px 15px;\n\n    }\n\n    .rulesBlock h2 {\n        font-size: 28px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ticketPage": `TicketEventPage_ticketPage__gX2oQ`,
	"header": `TicketEventPage_header__0JVCP`,
	"headersLocationName": `TicketEventPage_headersLocationName__jenIm`,
	"infoHeader": `TicketEventPage_infoHeader__mUwJk`,
	"logoImage": `TicketEventPage_logoImage__BFHAk`,
	"creepersImage": `TicketEventPage_creepersImage__+OpbO`,
	"container": `TicketEventPage_container__dMAMX`,
	"leftSection": `TicketEventPage_leftSection__VMY6N`,
	"rightSection": `TicketEventPage_rightSection__qnlXc`,
	"page": `TicketEventPage_page__EDyb0`,
	"description": `TicketEventPage_description__XkTHF`,
	"blockInfo": `TicketEventPage_blockInfo__+DHGu`,
	"blockDay": `TicketEventPage_blockDay__AoK7Q`,
	"blockWeek": `TicketEventPage_blockWeek__3vXna`,
	"blockTime": `TicketEventPage_blockTime__xaZii`,
	"btnGradient": `TicketEventPage_btnGradient__ZsJKC`,
	"blockCountry1": `TicketEventPage_blockCountry1__Q2E9r`,
	"blockInput": `TicketEventPage_blockInput__JvxD0`,
	"nameLinkDisabled": `TicketEventPage_nameLinkDisabled__nlr9a`,
	"error": `TicketEventPage_error__ql3na`,
	"titleAndAge": `TicketEventPage_titleAndAge__AvY-f`,
	"moneyBlock": `TicketEventPage_moneyBlock__W7HsP`,
	"footer": `TicketEventPage_footer__IAogb`,
	"footerLinksBlock": `TicketEventPage_footerLinksBlock__YkEEb`,
	"footerLinks": `TicketEventPage_footerLinks__QTkxP`,
	"block3": `TicketEventPage_block3__K4qVq`,
	"footerPaymentsBlock": `TicketEventPage_footerPaymentsBlock__0O4Aa`,
	"logoImageFooter": `TicketEventPage_logoImageFooter__S7V29`,
	"mainFootersComponent": `TicketEventPage_mainFootersComponent__dv8tw`,
	"footerDown": `TicketEventPage_footerDown__B3FXQ`,
	"leafsImageFooter": `TicketEventPage_leafsImageFooter__zHP0o`,
	"paymentImage": `TicketEventPage_paymentImage__VnluJ`,
	"paymentImage2": `TicketEventPage_paymentImage2__gX1H1`,
	"paymentsBlockImagesTwo": `TicketEventPage_paymentsBlockImagesTwo__UmO8n`,
	"scrollToTop": `TicketEventPage_scrollToTop__wdhai`,
	"ruleHeader": `TicketEventPage_ruleHeader__E4I-6`,
	"ruleSection": `TicketEventPage_ruleSection__+Cb-i`,
	"ruleContent": `TicketEventPage_ruleContent__lcVbZ`,
	"rulesBlock": `TicketEventPage_rulesBlock__hFslW`
};
export default ___CSS_LOADER_EXPORT___;
